import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";


const OrdersManagement = () => {
    const { ordernumber } = useParams();
    const [productPlaceOrder, setProductPlaceOrder] = useState([]);
    const [billPlaceOrder, setBillPlaceOrder] = useState([]);
    const [query, setQuery] = useState("");

    // const [products, SetProducts] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const { apiUrl } = useSelector(state => state.api);
    //list All Order in first page load 
    const listAllOrder = async () => {
        try {
            const response = await axios.get(`${apiUrl}/dashboard/placeorders`, {
                headers: { token: localStorage.getItem('token') }
            })

            //handle data place order from database
            const { getOrderBill, getOrderProduct } = response.data

            const combinedOrderBillProduct = getOrderBill?.map(bill => {
                const filterData = getOrderProduct?.filter(product => {
                    return product.order_number === bill.order_number
                })
                return filterData;
            });
            setCurrentPage(1)
            setProductPlaceOrder(combinedOrderBillProduct)
            setBillPlaceOrder(getOrderBill)
        } catch (err) {
            console.error(err.message);
        }
    };

    useEffect(() => {
        listAllOrder()
    }, [apiUrl])
    //handle Search order by query
    const handleSearch = async () => {
        const data = { query };
        try {
            if (!query) {
                listAllOrder();
                setCurrentPage(1);
            } else {
                const response = await axios.get(`${apiUrl}/dashboard/placeorders/search`, {
                    params: data,
                    headers: { token: localStorage.getItem('token') }
                });
                // console.log(response.data);
                //handle data place order from database
                const { getOrderBill, getOrderProduct } = response.data;
                console.log(getOrderBill, getOrderProduct);
                const combinedOrderBillProduct = getOrderBill?.map(bill => {
                    const filterData = getOrderProduct?.filter(product => {
                        return product.order_number === bill.order_number
                    })
                    return filterData;
                });
                setCurrentPage(1)
                setProductPlaceOrder(combinedOrderBillProduct)
                setBillPlaceOrder(getOrderBill)
            }

        } catch (err) {
            console.error(err.message);
            console.log(err.response);
            // setStatusSearch(err.response.data)
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };


    //handle Search orders By Date
    const handleSearchByDate = async (e) => {
        const selectedDate = e.target.value;
        const data = { selectedDate };
        try {
            if (data) {
                const response = await axios.get(`${apiUrl}/dashboard/placeordersbydate`, {
                    params: data,
                    headers: { token: localStorage.getItem('token') }
                });
                //handle data place order from database
                const { getOrderBill, getOrderProduct } = response.data;
                const combinedOrderBillProduct = getOrderBill?.map(bill => {
                    const filterData = getOrderProduct?.filter(product => {
                        return product.order_number === bill.order_number
                    });
                    return filterData;
                });
                setCurrentPage(1)
                setProductPlaceOrder(combinedOrderBillProduct)
                setBillPlaceOrder(getOrderBill)
            }
        } catch (err) {
            console.error(err.message);
            console.log(err.response);
            // setStatusSearch(err.response.data)
        }
    };


    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };



    useEffect(() => {
        //handle Get One Order by params
        const handleGetOneOrder = async () => {
            // const params = ordernumber;
            try {
                if (ordernumber) {
                    const response = await axios.get(`${apiUrl}/dashboard/placeorders/${ordernumber}`, {
                        headers: { token: localStorage.getItem('token') }
                    });
                    //handle data place order from database
                    const { getOrderBill, getOrderProduct } = response.data
                    const combinedOrderBillProduct = getOrderBill?.map(bill => {
                        const filterData = getOrderProduct?.filter(product => {
                            return product.order_number === bill.order_number
                        })
                        return filterData;
                    });
                    setCurrentPage(1)
                    setProductPlaceOrder(combinedOrderBillProduct)
                    setBillPlaceOrder(getOrderBill)
                }
            } catch (err) {
                console.error(err.message);
                console.log(err.response);
                // setStatusSearch(err.response.data)
            }
        };
        handleGetOneOrder()
    }, [ordernumber])

    //create index list orders
    const productsPerPage = 20;//number of product on page
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = productPlaceOrder.slice(indexOfFirstProduct, indexOfLastProduct);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="col-md-10 bg-light p-2 ">
            <div className="row d-flex justify-content-center">
                {/* date picker */}
                <div class="col-md-10 d-flex justify-content-end">
                    <div className="col-md-4 text-center p-2">
                        <div className="input-group mb-3">
                            <span className="input-group-text">Select Date:</span>
                            <input
                                id="startDate"
                                type="date"
                                className="form-control"
                                onChange={(e) => handleSearchByDate(e)}
                                data-bs-provide="datepicker"
                            />

                        </div>
                    </div>
                </div>
                {/* Search */}
                <div class="col-md-10 text-center">
                    <div className="input-group mb-3 ">
                        <input
                            type="text" className="form-control" aria-label="Search" aria-describedby="basic-addon2"
                            placeholder="You are can search by name product or ID order"
                            value={query}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                        <button
                            className="btn btn-outline-secondary" type="button" id="search-button"
                            onClick={handleSearch}
                        >Search
                        </button>
                    </div>
                </div>
                {/* list orders */}
                <div class="col-md-10 text-center">
                    {currentProducts?.map((element, ind) => (
                        <>


                            <div class="d-flex justify-content-start align-items-start mt-2 mb-2" style={{ "font-size": "14px" }}
                            >Your order ID:#
                                <Link to={`/dashboard/ordersmanagement/${billPlaceOrder[ind].order_number}`}
                                >{billPlaceOrder[ind].order_number}</Link>
                                -|-{new Date(billPlaceOrder[ind].order_time).toLocaleString().replace(',', '')}

                            </div >
                            <table class="table">
                                <thead class="table-primary">
                                    <tr>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                        <th>Total</th>

                                    </tr>
                                </thead>
                                {element?.map(item => (
                                    <tbody >

                                        <tr>
                                            <td class="text-start">
                                                <img src={apiUrl + "/" + item.product_img}
                                                    alt={item.product_name}
                                                    style={{ height: "80px", width: " 80px" }} />
                                                {item.product_name}
                                            </td>
                                            <td>{item.order_quantity}</td>
                                            <td>{item.product_price.toLocaleString('en-US',
                                                { minimumFractionDigits: 2, maximumFractionDigits: 2, }).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</td>
                                        </tr>

                                    </tbody>
                                ))}
                                <thead class="table-success">
                                    <tr>
                                        <th></th>
                                        <th>Order Total:</th>
                                        <th>${billPlaceOrder[ind].order_bill.toLocaleString('en-US', {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2,
                                        }).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</th>
                                    </tr>
                                </thead>
                            </table>
                            <div class="infoDelivery">
                                <div>Delivery: {billPlaceOrder[ind].user_name} - {" "}
                                    {billPlaceOrder[ind].user_phone} - {" "}
                                    {billPlaceOrder[ind].user_address} {billPlaceOrder[ind].user_state} {billPlaceOrder[ind].user_city}

                                </div>




                            </div >




                        </>
                    ))}
                    {(currentProducts.length <= 0) && <div>No orders yet.</div>}
                    {/* {statusSearch} */}

                    <div className="pagination-container">
                        <nav aria-label="Page navigation">
                            <ul className="pagination">
                                {Array.from({ length: Math.ceil(productPlaceOrder.length / productsPerPage) },
                                    (_, i) => i + 1).map((pageNumber) => (
                                        <li className={`page-item ${currentPage === pageNumber ? 'active' : ''}`} key={pageNumber}>
                                            <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                                                {pageNumber}
                                            </button>
                                        </li>
                                    )
                                    )}
                            </ul>
                        </nav>
                    </div>

                </div>
            </div>
        </div >


    )
}
export default OrdersManagement;